import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const MessageHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData = labels.menuPages?.sellCar?.messageHeader || {};

  return (
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 max-w-4xl mx-auto">
        {headerData.title || "Revolutionen Inom Bilförsäljning"}
      </h2>
      <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
        {headerData.description ||
          "BILENIA förändrar hur du säljer din bil. Från Sverige till hela Europa."}
      </p>
    </div>
  );
};

export default MessageHeader;
